import { DC } from "../../constants";

const rebuyable = props => {
  props.cost = () => getHybridCostScaling(
    player.reality.rebuyables[props.id],
    1e30,
    props.initialCost,
    props.costMult,
    props.costMult / 10,
    DC.E309,
    1e3,
    props.initialCost * props.costMult
  );
  const { effect } = props;
  props.effect = () => Math.pow(
    effect + ImaginaryUpgrade(props.id).effectOrDefault(0),
    player.reality.rebuyables[props.id] * getAdjustedGlyphEffect("realityrow1pow"));
  props.description = () => props.textTemplate.replace("{value}",
    ImaginaryUpgrade(props.id).effectValue === 0
      ? formatInt(effect)
      : format(effect + ImaginaryUpgrade(props.id).effectValue, 2, 2));
  props.formatEffect = value => formatX(value, 2, 0);
  props.formatCost = value => format(value, 2, 0);
  return props;
};


export const realityUpgrades = [
  rebuyable({
    name: "Темпоральное Усиление",
    id: 1,
    initialCost: 1,
    costMult: 30,
    textTemplate: "Вы зарабатываете Растянутое Время в {value} раз быстрее",
    effect: 3
  }),
  rebuyable({
    name: "Репликативное Усиление",
    id: 2,
    initialCost: 1,
    costMult: 30,
    textTemplate: "Вы зарабатываете Репликантов в {value} раз быстрее",
    effect: 3
  }),
  rebuyable({
    name: "Вечное Усиление",
    id: 3,
    initialCost: 2,
    costMult: 30,
    textTemplate: "Вы зарабатываете в {value} раз больше Вечностей",
    effect: 3
  }),
  rebuyable({
    name: "Сверхсветовое Усиление",
    id: 4,
    initialCost: 2,
    costMult: 30,
    textTemplate: "Вы зарабатываете в {value} раз больше Тахион Частиц",
    effect: 3
  }),
  rebuyable({
    name: "Безграничное Усиление",
    id: 5,
    initialCost: 3,
    costMult: 50,
    textTemplate: "Вы зарабатываете в {value} раз больше Бесконечностей",
    effect: 5
  }),
  {
    name: "Космически Дублированный",
    id: 6,
    cost: 15,
    requirement: "Пройдите вашу первую ручную Вечность без использования Галактик Репликантов",
    // Note that while noRG resets on eternity, the reality-level check will be false after the first eternity.
    // The noRG variable is eternity-level as it's also used for an achievement check
    hasFailed: () => !(player.requirementChecks.eternity.noRG && player.requirementChecks.reality.noEternities),
    checkRequirement: () => player.requirementChecks.eternity.noRG && player.requirementChecks.reality.noEternities,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    canLock: true,
    lockEvent: "получить Галактику Репликантов",
    description: "Скорость Репликантов умножена, основываясь на Галактиках Репликантов",
    effect: () => 1 + Replicanti.galaxies.total / 50,
    formatEffect: value => formatX(value, 2, 2)
  },
  {
    name: "Бесчисленно Конструктный",
    id: 7,
    cost: 15,
    requirement: "Пройдите вашу первую Бесконечность с максимумом 1ой Галактикой Антиматерии",
    hasFailed: () => !(player.galaxies <= 1 && player.requirementChecks.reality.noInfinities),
    checkRequirement: () => player.galaxies <= 1 && player.requirementChecks.reality.noInfinities,
    checkEvent: GAME_EVENT.BIG_CRUNCH_BEFORE,
    canLock: true,
    lockEvent: "получить ещё одну Галактику Антиматерии",
    description: "Заработок Бесконечностей увеличен от количества Галактик Антиматерии",
    effect: () => 1 + player.galaxies / 30,
    formatEffect: value => formatX(value, 2, 2)
  },
  {
    name: "Парадоксальное Достижение",
    id: 8,
    cost: 15,
    requirement: "Вручную завершите Вечность без каких-либо автоматических Достижений",
    hasFailed: () => player.reality.gainedAutoAchievements,
    checkRequirement: () => !player.reality.gainedAutoAchievements,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    canLock: true,
    // We don't have lockEvent because the modal can never show up for this upgrade
    description: "Заработок Тахион Частиц увеличен на основе множителя Достижений",
    effect: () => Math.sqrt(Achievements.power),
    formatEffect: value => formatX(value, 2, 2)
  },
  {
    name: "Лингвистическое Расширение",
    id: 9,
    cost: 15,
    requirement: () => `Вечность за ${format("1e4000")} Очков Вечности, используя только
      один Глиф уровня ${formatInt(3)}+.`,
    hasFailed: () => {
      const invalidEquippedGlyphs = Glyphs.activeWithoutCompanion.length > 1 ||
        (Glyphs.activeWithoutCompanion.length === 1 && Glyphs.activeWithoutCompanion[0].level < 3);
      const hasValidGlyphInInventory = Glyphs.inventory.countWhere(g => g && g.level >= 3) > 0;
      return invalidEquippedGlyphs || (Glyphs.activeWithoutCompanion.length === 0 && !hasValidGlyphInInventory);
    },
    checkRequirement: () => Currency.eternityPoints.exponent >= 4000 &&
      Glyphs.activeWithoutCompanion.length === 1 && Glyphs.activeWithoutCompanion[0].level >= 3,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
    canLock: true,
    // There are two locking events - equipping a glyph with too low a level, and equipping a second glyph
    description: "Получите ещё один слот для Глифа",
    effect: () => 1
  },
  {
    name: "Экзистенциальное Продление",
    id: 10,
    cost: 15,
    requirement: () => `Пройдите вашу первую речную Вечность как минимум с ${formatPostBreak(DC.E400)} Очками Вечности`,
    hasFailed: () => !player.requirementChecks.reality.noEternities,
    checkRequirement: () => Currency.infinityPoints.exponent >= 400 &&
      player.requirementChecks.reality.noEternities,
    checkEvent: GAME_EVENT.ETERNITY_RESET_BEFORE,
    canLock: true,
    lockEvent: "завершить Вечность",
    bypassLock: () => Currency.infinityPoints.exponent >= 400,
    description: () => `Начинайте каждую Реальность с ${formatInt(100)} Вечностями (также применяется к текущей
      Реальности)`,
    automatorPoints: 15,
    shortDescription: () => `Начинайте с ${formatInt(100)} Вечностями`,
    effect: () => 100
  },
  {
    name: "Безграничный Поток",
    id: 11,
    cost: 50,
    requirement: () => `${format(Currency.infinitiesBanked.value, 2)}/${format(DC.E12)} Banked Infinities`,
    checkRequirement: () => Currency.infinitiesBanked.exponent >= 12,
    checkEvent: [GAME_EVENT.ETERNITY_RESET_AFTER, GAME_EVENT.REALITY_FIRST_UNLOCKED],
    description: "Каждую секунду, получайте 10% Бесконечностей, которые вы получили бы за Хруст",
    automatorPoints: 5,
    shortDescription: () => `Продолжительная генерация Бесконечностей`,
    effect: () => gainedInfinities().times(0.1),
    formatEffect: value => `${format(value)} в секунду`
  },
  {
    name: "Знающее Существование",
    id: 12,
    cost: 50,
    requirement: () => `Вечность за ${format(DC.E70)} Очков Вечности без прохождения Вечного Челленджа 1`,
    hasFailed: () => EternityChallenge(1).completions !== 0,
    checkRequirement: () => Currency.eternityPoints.exponent >= 70 && EternityChallenge(1).completions === 0,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
    canLock: true,
    lockEvent: "завершить Вечный Челлендж 1",
    description: "Множитель Очков Вечности, основанный на количестве Реальностей и Временны́х Теорем",
    effect: () => Currency.timeTheorems.value
      .minus(DC.E3).clampMin(2)
      .pow(Math.log2(Math.min(Currency.realities.value, 1e4))).clampMin(1),
    formatEffect: value => formatX(value, 2, 2)
  },
  {
    name: "Телемеханический Процесс",
    id: 13,
    cost: 50,
    requirement: () => `Вечность за ${format(DC.E4000)} Очков Вечности без Изм. Времени 5-8`,
    hasFailed: () => !Array.range(5, 4).every(i => TimeDimension(i).amount.equals(0)),
    checkRequirement: () => Currency.eternityPoints.exponent >= 4000 &&
      Array.range(5, 4).every(i => TimeDimension(i).amount.equals(0)),
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
    canLock: true,
    lockEvent: "купить Измерение Времени выше 4ого ИВ",
    description: () => `Улучшить АвтоПокупщик Вечности, открыть АвтоПокупщики для Измерений Времени и ${formatX(5)} ОВ`,
    automatorPoints: 10,
    shortDescription: () => `АвтоПокупщики ИВ и ${formatX(5)} ОВ, улучшенный АвтоПокупщик Вечности`,
  },
  {
    name: "Вечный Поток",
    id: 14,
    cost: 50,
    requirement: () => `${format(Currency.eternities.value, 2)}/${format(1e7)} Eternities`,
    checkRequirement: () => Currency.eternities.gte(1e7),
    checkEvent: [GAME_EVENT.ETERNITY_RESET_AFTER, GAME_EVENT.REALITY_FIRST_UNLOCKED],
    description: "Получайте Вечности в секунду, равные вашему количеству Реальностей",
    automatorPoints: 5,
    shortDescription: () => `Продолжительная генерация Вечностей`,
    effect: () => Currency.realities.value * Ra.unlocks.continuousTTBoost.effects.eternity.effectOrDefault(1),
    formatEffect: value => `${format(value)} в секунду`
  },
  {
    name: "Парадоксальное Навсегда",
    id: 15,
    cost: 50,
    requirement: () => `Получите ${format(DC.E10)} Очков Вечности без покупки
      улучшения в ${formatX(5)} Очков Вечности`,
    hasFailed: () => player.epmultUpgrades !== 0,
    checkRequirement: () => Currency.eternityPoints.exponent >= 10 && player.epmultUpgrades === 0,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
    canLock: true,
    lockEvent: () => `купить ${formatX(5)} множитель ОВ`,
    description: () => `Увеличить заработок Тахион Частиц на основе ${formatX(5)} множителя Очков Вечности`,
    effect: () => Math.max(Math.sqrt(Decimal.log10(EternityUpgrade.epMult.effectValue)) / 9, 1),
    formatEffect: value => formatX(value, 2, 2)
  },
  {
    name: "Диспропорция Редкости",
    id: 16,
    cost: 1500,
    requirement: () => `Реальность с ${formatInt(4)} экипированными Глифами качества необычный или выше
      (${formatInt(Glyphs.activeWithoutCompanion.countWhere(g => g && g.strength >= 1.5))} экипировано)`,
    hasFailed: () => {
      const availableGlyphs = Glyphs.inventory.countWhere(g => g && g.strength >= 1.5);
      const equipped = Glyphs.activeWithoutCompanion.countWhere(g => g.strength >= 1.5);
      const availableSlots = Glyphs.activeSlotCount - Glyphs.activeList.length;
      return equipped + Math.min(availableGlyphs, availableSlots) < 4;
    },
    checkRequirement: () => Glyphs.activeWithoutCompanion.countWhere(g => g.strength >= 1.5) === 4,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    description: "Улучшение формулы редкости Глифов",
    effect: 1.3,
    formatCost: value => format(value, 1, 0)
  },
  {
    name: "Двойственность Потенции",
    id: 17,
    cost: 1500,
    requirement: () => `Реальность с ${formatInt(4)} экипирванными Глифами, каждый имеет как минимум ${formatInt(2)}
      эффекта (${formatInt(Glyphs.activeWithoutCompanion.countWhere(g => g && countValuesFromBitmask(g.effects) >= 2))}
      экипировано)`,
    hasFailed: () => {
      const availableGlyphs = Glyphs.inventory.countWhere(g => g && countValuesFromBitmask(g.effects) >= 2);
      const equipped = Glyphs.activeWithoutCompanion.countWhere(g => countValuesFromBitmask(g.effects) >= 2);
      const availableSlots = Glyphs.activeSlotCount - Glyphs.activeList.length;
      return equipped + Math.min(availableGlyphs, availableSlots) < 4;
    },
    checkRequirement: () => Glyphs.activeWithoutCompanion.countWhere(g => countValuesFromBitmask(g.effects) >= 2) === 4,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    description: () => `${formatPercents(0.5)} шанс на получение дополнительного эффекта у Глифов`,
    effect: 0.5,
    formatCost: value => format(value, 1, 0)
  },
  {
    name: "Мера Навсегда",
    id: 18,
    cost: 1500,
    requirement: () => `Реальность с ${formatInt(4)} экипированными Глифами, каждый уровнем ${formatInt(10)} или выше
      (${formatInt(Glyphs.activeWithoutCompanion.countWhere(g => g && g.level >= 10))} экипировано)`,
    hasFailed: () => {
      const availableGlyphs = Glyphs.inventory.countWhere(g => g && g.level >= 10);
      const equipped = Glyphs.activeWithoutCompanion.countWhere(g => g.level >= 10);
      const availableSlots = Glyphs.activeSlotCount - Glyphs.activeList.length;
      return equipped + Math.min(availableGlyphs, availableSlots) < 4;
    },
    checkRequirement: () => Glyphs.activeWithoutCompanion.countWhere(g => g.level >= 10) === 4,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    description: "Количество Вечностей даёт бонус к уровню Глифов",
    effect: () => Math.max(Math.sqrt(Currency.eternities.value.plus(1).log10()) * 0.45, 1),
    formatCost: value => format(value, 1, 0)
  },
  {
    name: "Обыскивай для Уполномочивания",
    id: 19,
    cost: 1500,
    requirement: () => `Имейте всего ${formatInt(30)} или больше Глифов за раз
      (У вас есть ${formatInt(Glyphs.allGlyphs.countWhere(g => g.type !== "companion"))})`,
    hasFailed: () => Glyphs.allGlyphs.countWhere(g => g.type !== "companion") < 30,
    checkRequirement: () => Glyphs.allGlyphs.countWhere(g => g.type !== "companion") >= 30,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    description: "Вы можете Жертвовать Глифы для постоянных бонусов (Shift + клик)",
    formatCost: value => format(value, 1, 0)
  },
  {
    name: "Паритет Сингулярности",
    id: 20,
    cost: 1500,
    requirement: () => `${formatInt(100)} днец общее игровое время после открытия Чёрной Дыры
      (Сейчас: ${Time.timeSinceBlackHole.toStringShort(false)})`,
    hasFailed: () => !BlackHole(1).isUnlocked && Currency.realityMachines.lt(100),
    checkRequirement: () => Time.timeSinceBlackHole.totalDays >= 100 && BlackHole(1).isUnlocked,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: "Разблокируйте другую Чёрную Дыру",
    automatorPoints: 10,
    shortDescription: () => `Вторая Чёрная Дыра`,
    formatCost: value => format(value, 1, 0)
  },
  {
    name: "Космический Конгломерат",
    id: 21,
    cost: 100000,
    requirement: () => `${formatInt(Replicanti.galaxies.total + player.galaxies +
      player.dilation.totalTachyonGalaxies)}/${formatInt(2800)} всего Галактик со всех типов`,
    checkRequirement: () =>
      Replicanti.galaxies.total + player.galaxies + player.dilation.totalTachyonGalaxies >= 2800,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: () => `Масштабирование Отдалённых Галактик сдвинуто до ${formatInt(1e5)} галактик`,
    effect: 1e5
  },
  {
    name: "Темпоральная Трансцендентность",
    id: 22,
    cost: 100000,
    requirement: () => `${format(Currency.timeShards.value, 1)}/${format(DC.E28000)} Time Shards`,
    checkRequirement: () => Currency.timeShards.exponent >= 28000,
    checkEvent: GAME_EVENT.GAME_TICK_AFTER,
    description: "Множитель Измерений Времени, основанный на количестве дней, проведённых в текущей Реальности",
    effect: () => Decimal.pow10(Math.pow(1 + 2 * Math.log10(Time.thisReality.totalDays + 1), 1.6)),
    formatEffect: value => formatX(value, 2, 2)
  },
  {
    name: "Репликативная Стремительность",
    id: 23,
    cost: 100000,
    requirement: () => `Реальность за ${formatInt(15)} минут игрового времени
      (Самая быстрая: ${Time.bestReality.toStringShort()})`,
    hasFailed: () => Time.thisReality.totalMinutes >= 15,
    checkRequirement: () => Time.thisReality.totalMinutes < 15,
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    description: "Скорость Репликантов увеличена, основываясь на самой быстрой Реальности (игрового времени)",
    effect: () => 15 / Math.clamp(Time.bestReality.totalMinutes, 1 / 12, 15),
    cap: 180,
    formatEffect: value => formatX(value, 2, 2)
  },
  {
    name: "Синтетический Символизм",
    id: 24,
    cost: 100000,
    requirement: () => `Реальность за ${formatInt(5000)} Машин Реальности без экипированных Глифов`,
    hasFailed: () => Glyphs.activeWithoutCompanion.length > 0,
    checkRequirement: () => MachineHandler.gainedRealityMachines.gte(5000) &&
      Glyphs.activeWithoutCompanion.length === 0,
    canLock: true,
    lockEvent: "экипировать не-компаньонский Глиф",
    checkEvent: GAME_EVENT.REALITY_RESET_BEFORE,
    description: "Получите ещё один слот для Глифов",
    effect: () => 1
  },
  {
    name: "Непринуждённое Существование",
    id: 25,
    cost: 100000,
    requirement: () => `Достигните ${format(DC.E11111)} ОВ (Лучшее: ${
      format(player.records.bestReality.bestEP, 2)} ОВ)`,
    checkRequirement: () => player.records.bestReality.bestEP.exponent >= 11111,
    checkEvent: GAME_EVENT.ETERNITY_RESET_AFTER,
    description: "Разблокируйте АвтоПокупщик Реальности и соответствующую команду Автоматизатора",
    automatorPoints: 100,
    shortDescription: () => `АвтоПокупщик Реальности`,
  },
];
